import React, { ReactNode, FunctionComponent, MouseEventHandler } from "react";

type EmblaCarouselThumbsProps = {
  selected: boolean;
  onClick: MouseEventHandler;
  children?: ReactNode;
};

export const Thumb: FunctionComponent<EmblaCarouselThumbsProps> = ({
  selected,
  onClick,
  children,
}) => (
  <div
    className={`embla__slide embla__slide--thumb ${
      selected ? "is-selected" : ""
    }`}
  >
    <button
      onClick={onClick}
      className="embla__slide__inner embla__slide__inner--thumb"
      type="button"
    >
      {children}
    </button>
  </div>
);

export default Thumb;
